import Map from "@/utils/Map";

export default class Map_DynamicMissionEvents {
  isfreeze;
  geom;
  distmin;
  pickedIndex;
  isMove;

  constructor(geom) {
    this.geom = geom;
    this.isfreeze = false;
    this.distmin = 3;
    this.pickedIndex = -1;
    this.isMove = false;
  }

  preRender() {
    const keypressed = Map.getKeyPressed();
    keypressed.forEach((action) => {
      if(action === "MOVE-UP") {
        this.geom.moveDrone([-1,0,0], [0,0,0]);
      }
      if(action === "MOVE-DOWN") {
        this.geom.moveDrone([1,0,0], [0,0,0]);
      }
      if(action === "MOVE-LEFT") {
        this.geom.moveDrone([0,-1,0], [0,0,0]);
      }
      if(action === "MOVE-RIGHT") {
        this.geom.moveDrone([0,1,0], [0,0,0]);
      }
      if(action === "ROOL-LEFT") {
        this.geom.moveDrone([0,0,0], [-0.5,0,0]);
      }
      if(action === "ROOL-RIGHT") {
        this.geom.moveDrone([0,0,0], [0.5,0,0]);
      }
      if(action === "DRONE-UP") {
        this.geom.moveDrone([0,0,0.5], [0,0,0]);
      }
      if(action === "DRONE-DOWN") {
        this.geom.moveDrone([0,0,-0.5], [0,0,0]);
      }
    });
    if(keypressed.length>0){
      this.setKeyInfos();
    }

  }

  isValidIndex(index) {
    return  index >= 0 && index < this.geom.controlspoints.length;
  }

  async setKeyInfos() {

    const index = this.geom.selectedIndex;
    if(this.isValidIndex(index)) {

      let cartographic = this.geom.drone.position.clone();
      cartographic = await this.geom.convertHeightToGlobal(cartographic, true);

      const heading = this.geom.drone.heading - 90;
      const speed = this.geom.drone.speed;
      const follow = this.geom.controlspoints[index].followroute;
      if(Cesium.defined(cartographic)) {
        Map.setKeyInfos(cartographic.longitude, cartographic.latitude, cartographic.height, heading, speed, follow);
        this.updateMissionAction("rotateYaw", heading);
      }
    }
  }

  isActive() {

    return Cesium.defined(this.geom.takeoff.position);
  }

  freezeCamera(isFreeze) {
    this.geom.viewer.scene.screenSpaceCameraController.enableRotate = !isFreeze;
    this.geom.viewer.scene.screenSpaceCameraController.enableTranslate =
      !isFreeze;
    this.geom.viewer.scene.screenSpaceCameraController.enableZoom = !isFreeze;
    this.geom.viewer.scene.screenSpaceCameraController.enableTilt = !isFreeze;
    this.geom.viewer.scene.screenSpaceCameraController.enableLook = !isFreeze;
    this.isfreeze = isFreeze;
  }

  isFreeze() {
    return this.isfreeze;
  }

  isPicked(index) {

    let ispick = false;
    if (this.geom.pickedInfos !== undefined && this.geom.pickedInfos.element && this.geom.isKmz === true ) {
      ispick = this.geom.pickedInfos.element === "waypointMission" + index;
    }
    return ispick;
  }

  isSelected(index) {
    return this.pickedIndex === index;
  }

  getPicked(onlyControl) {

    let index = -1;
    if (this.geom.pickedInfos !== undefined && this.geom.pickedInfos.element && this.geom.pickedInfos.element !== "" && this.geom.isKmz === true ) {
      this.geom.controlspoints.forEach((controlspoint,i) => {
        if(onlyControl === true) {
          if(controlspoint.control.name === this.geom.pickedInfos.element) {
            index = i;
          }
        }
        else{
          if(controlspoint.control.name === this.geom.pickedInfos.element) {
            index = i;
          }
          if(controlspoint.point.name === this.geom.pickedInfos.element) {
            index = i;
          }
        }
      });
    }

    return index;
  }

  isNoReturn(index) {

    let result = false;
    if(this.isValidIndex(index)) {
      result = this.geom.controlspoints[index].isNoReturn;
    }
    return result;
  }

  isControlPointPicked(index) {
    let ispick = false;
    if (this.geom.pickedInfos !== undefined && this.geom.pickedInfos.position) {

      const cartesian = this.geom.cartesian3FromCartographicDegrees(
        this.geom.pickedInfos.position
      );
      const dist = Cesium.Cartesian3.distance(
        cartesian,
        this.geom.getControlPointCartesian(index)
      );
      if (dist < this.distmin) {
        ispick = true;
      }
    }

    return ispick;
  }


  activateContextMenu(infos) {
    this.geom.viewer.scene.screenSpaceCameraController.enableZoom = false;
    this.desactivateContexMenu();
    Map.setInfosContextMenuWaypt(infos);
  }

  activateContextMenuDelete(infos) {
    this.geom.viewer.scene.screenSpaceCameraController.enableZoom = false;
    this.desactivateContexMenu();
    Map.setInfosContextMenuWayptDelete(infos);
  }

  desactivateContexMenu() {
    this.geom.viewer.scene.screenSpaceCameraController.enableZoom = true;
    Map.toggle_popup_contextmenuwaypointDelete(false);
    Map.toggle_popup_contextmenuwaypoint(false);
  }

/*
  setNoReturn(index) {
    Map.setMapAction({action :"noreturn", index:index, value:this.isNoReturn(index)});
  }

  deleteWpt(index) {
    Map.setMapAction({action :"delete", index:index, value : undefined});
  }
*/
/*
  addWpt(index, cartesian) {
    Map.setMapAction({action :"add", index : index, value : [cartesian.longitude, cartesian.latitude, cartesian.height]});
  }
  */
  updateTimeInfos() {
    Map.setMapAction({action :"updateTime", index : undefined, value : undefined});
  }

  selectStep(index) {
    Map.setMapAction({action :"select", index:index, value : undefined});
  }

  updateMissionAction(type, value) {
    if($root.global.flightedit.missionActionUpdate && ($root.global.flightedit.missionActionUpdate.type === type || $root.global.flightedit.missionActionUpdate.actuatorfunc === "orientedShoot")) {

      const infos = {
        actionGrpID : $root.global.flightedit.missionActionUpdate.actionGrpID,
        actionID: $root.global.flightedit.missionActionUpdate.actionID,
        stepID: $root.global.flightedit.missionActionUpdate.stepID,
        actuatorfunc : $root.global.flightedit.missionActionUpdate.actuatorfunc,
        type: type,
        value : value,
      }

      let sauvList = [];
      if($root.global.flightedit.missionActionUpdateList === undefined) {
        $root.global.flightedit.missionActionUpdateList = [];
      }
      $root.global.flightedit.missionActionUpdateList.forEach((action) =>  {
        sauvList.push(action);
      });
      sauvList.push(infos);
      $root.global.flightedit.missionActionUpdateList = sauvList;
    }
  }

}
